import React from 'react';
import Button from '../../../ui_kit/button/Button';
import styles from './JoinUsButton.module.sass';

function JoinUsButton() {
  return (
    <Button
      className={styles.join}
      color="yellow"
      text="join us"
      href="https://docs.google.com/forms/d/e/1FAIpQLSc2NF__gvi6sBkmHN5p3Yhe0GJylXcdQLYFUFv-kXT0QCs8Ww/viewform"
    />
  );
}

export default JoinUsButton;
